<template>
  <Modal @close="$emit('close-modal')">
    <Loading v-if="loading" />
    <template v-slot:title>
      {{is_pt_br ? 'Cadastrar 3D' : 'Register'}}
    </template>
    <template>
      <FormBox
        :messageError="messageError"
        @clean-error="messageError = ''"
        :loading="loading"
      >
        <template v-slot:header> </template>
        <template>
          <InputDroFile :files="files" 
          :placeholder="is_pt_br ? 'Selecionar arquivo' : 'Select file'"
          :legend="is_pt_br ? 'Arraste ou selecione os aquivos aqui' : 'Drag or select files here'"
          />
        </template>
        <template v-slot:footer>
          <div class="col-12 mt-2 p-0 d-flex justify-content-end">
            <button
              @click.prevent="uploadFiles()"
              class="btn btn-outline-dark"
              :disabled="files == 0"
            >
              Add
            </button>
          </div>
        </template>
      </FormBox>
    </template>
  </Modal>
</template>

<script>
import Modal from "../utils/Modal.vue";
import FormBox from "../utils/BoxForm.vue";
import InputDroFile from "../utils/InputDropFile.vue";
import Loading from "../utils/AnimateLoad.vue";
import { mapActions } from "vuex";

export default {
  name: "New3D",
  props: { stone_id: Number },
  components: { Modal, FormBox, InputDroFile, Loading },
  data() {
    return {
      loading: false,
      files: [],
      messageError: "",
    };
  },
  computed: {
    is_pt_br() {
      return this.$store.getters.is_pt_br;
    },
  },
  methods: {
    ...mapActions("stone", ["upLoadFiles3D"]),

    previewFiles(event) {
      this.fileSelected = event.target.files;
    },

    async uploadFiles() {
      console.log(this.files);
      this.loading = true;
      await this.upLoadFiles3D({
        stone_id: this.stone_id,
        files: this.files,
        adjust_rotation: 0,
      })
        .then((res) => {
          this.$emit("close-modal");
          this.$emit("create-3d", null);
        })
        .catch((error) => {
          this.$emit("create-3d", error);
          this.messageError = error;
          console.error(error);
        });
      this.loading = false;
    },
  },
};
</script>
